let mdName = function(str){
  if(!str) return;
  if(str.length >= 7){
    return str.substr(0,3)+'****'+ str.substring(str.length-6)
  }else{
      return str;
  }
}
// 全局去掉小数点2位和4位
let toFixed4 = function(val){
  // if(val == 0 || val){
  //   val = Number(val);
  //   return val.toFixed(4);
  // }else{
  //   return ''
  // }
  return val
}
let toFixed2 = function(val){
  // val = Number(val);
  // return val.toFixed(2);
  return val
}

let rewriteName = function(val){
  let bzName = val;
  if(val == 'CMGCA0'){
    bzName = 'XAU';
    return bzName
  }else if(val == 'CMSIA0'){
    bzName = 'XAG';
    return bzName
  }else if(val == 'CMHGA0'){
    bzName = 'BRT';
    return bzName
  }else if(val == 'NECLI0'){
    bzName = 'OILFUT';
    return bzName
  }else if(val == 'NEHOI0'){
    bzName = 'NYMEX';
    return bzName
  }else if(val == 'NENGA0'){
    bzName = 'NG';
    return bzName
  }else if(val == 'NEPAA0'){
    bzName = 'XPD';
    return bzName
  }else if(val == 'NEPLA0'){
    bzName = 'PTB';
    return bzName
  }else if(val == 'NEQMA0'){
    bzName = 'QMOIL';
    return bzName
  }else if(val == 'NERBA0'){
    bzName = 'RBOB';
    return bzName
  }else{
    return bzName
  }
}
let timeGs = function(val){
  var date = new Date((val) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  var dates = Y + M + D + " " + h + m + s;;
  if(dates){
    let times = dates.split('-');
    let timess = times[2].split(' ');
    let mm = times[1];
    let dd = timess[0];
    let year = times[0];
    let sfm = timess[1];
    return year + '-' + mm + '-' + dd + " " + sfm;;
  }
}
let timeGs2 = function(val){
  var date = new Date((val) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  var dates = Y + M + D;
  if(dates){
  let times = dates.split('-');
  let mm = times[1];
  let dd = times[2];
  let year = times[0];
  return year + '-' + mm + '-' + dd
  }
}

let times = function(timess,timestamp){
    // var date = new Date((timess - timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    // var Y = date.getFullYear() + '-';
    // var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
    // var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    // var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    // var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    // return Y + M + D + " " + h + m + s;
    if(timestamp==1){
      timestamp = 0
    }
    const date = new Date((timess - timestamp)* 1000);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以+1
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
let times2 = function(timess,timestamp){
    var date = new Date((timess - timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    return Y + M + D;
}
// let mdName = function(str){
//   if(!str) return;
//   if(str.length >= 8){
//       return str.substr(0,4)+'*****'+str.substr(str.split('').length-3)
//   }else{
//       return str;
//   }
// }
// let toFixed4 = function(val,defval,cname){
//   var leng;
//   val = parseFloat(val);
//   if(cname){
//     if(cname == 'AUDUSD' || cname == 'GBPUSD' || cname == 'EURUSD' || cname == 'NZDUSD' || cname == 'USDCAD' || cname == 'USDCHF' || cname == 'USDCNH' || cname == 'USDHKD' || cname == 'USDSGD' || cname == 'EURAUD' || cname == 'EURCAD' || cname == 'EURGBP' || cname == 'EURNZD' || cname == 'GBPAUD' || cname == 'GBPCAD' || cname == 'GBPCHF' || cname == 'GBPNZD' || cname == 'NZDCAD' || cname == 'NZDCHF' || cname == 'CADCHF' || cname == 'AUDCAD' || cname == 'AUDCHF' || cname == 'xrpusdt' || cname == 'XRP'){
//       leng = 5
//     }else if(cname == 'USDJPY' || cname == 'EURJPY' || cname == 'GBPJPY' || cname == 'NZDJPY' || cname == 'AUDNZD' || cname == 'CADJPY' || cname == 'CHFJPY' || cname == 'AUDJPY' || cname == 'XAGUSD' || cname == 'eosusdt' || cname == 'EOS'){
//       leng = 3
//     }else if(cname == 'XAUUSD' || cname == 'BTCUSD' || cname == 'ETHUSD' || cname == 'LTCUSD' || cname == 'BCHUSD' || cname == 'BTC' || cname == 'ETH' || cname == 'LTC' || cname == 'BCH'){
//       leng = 2
//     }else if(cname == 'TRX' || cname == 'TRXUSD'){
//       leng = 6
//     }else{
//       if(defval.toString().indexOf(".") > -1){
//         if(!isNaN(defval.toString().split('.')[0]) || defval.toString().split('.')[1] != undefined){
//           leng = defval.toString().split('.')[1].length;
//         }
//       }else{
//         leng = 0
//       }
//     }
//   }else{
//     if(defval){
//       if(defval.toString().indexOf(".") > -1){
//         if(!isNaN(defval.toString().split('.')[0]) || defval.toString().split('.')[1] != undefined){
//           leng = defval.toString().split('.')[1].length;
//         }
//       }else{
//         leng = leng
//       }
//     }
//   }
//   return val.toFixed(leng);
// }
let balance = function(val){
  val = parseFloat(val);
  return val.toFixed(2);
}
// let toFixed2 = function(val){
//   val = Number(val);
//   return val.toFixed(2);
// }
let toFixed = function(val){
  val = parseFloat(val);
  return val;
}
let bzName = function(val){
  var bzNew;
  if(val){
    var newArr = val.split('USD');
  var leng = newArr.length;
  if(leng == 1){
    bzNew = val
  }else{
    if(newArr[0] == ''){
      bzNew = 'USD/' + newArr[1]
    }else{
      bzNew = newArr[0] + '/USD'
    }
  }
  return bzNew;
}
}

let toUpperCase = function(val){
  return val.toUpperCase();
}
let toFixed44 = function(val){
  if(val == 0 || val){
    val = Number(val);
    return val.toFixed(4);
  }else{
    return ''
  }
}
let toFixed66 = function(val){
  if(val == 0 || val){
    val = Number(val);
    return val.toFixed(6);
  }else{
    return ''
  }
}

// const number = 123.456;


// console.log(formatter.format(number)); // 输出: "123.456" 或者如果原始数字是小数但不是三位，则显示相应的小数位，例如 "123.4" 或 "123"
// 数字格式化
let formatNumberWithCommas = function(number) {
    if(typeof number==="undefined"){
      return 0
    }
    const formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: Math.min(6, (number.toString().split('.')[1] || []).length), // 如果number有小数部分，则使用其长度，否则默认为0
        maximumFractionDigits: 6 // 最大为3位小数
    });
    return formatter.format(number);
}

// let formatNumberWithCommas = function(number) {
//     return new Intl.NumberFormat().format(number);
// }

// function truncateNumber(value, decimals) {
//     const factor = Math.pow(10, decimals);
//     const truncatedValue = Math.trunc(value * factor) / factor;
//     return new Intl.NumberFormat('en-US', {
//         minimumFractionDigits: decimals,
//         maximumFractionDigits: decimals,
//         useGrouping: true // 使用逗号作为千位分隔符
//     }).format(truncatedValue);
// }

// export {rewriteName,timeGs,timeGs2,mdName,toFixed4,toFixed2}
export {formatNumberWithCommas,rewriteName,timeGs,timeGs2,mdName,toFixed4,toFixed2,times,times2,balance,toFixed,bzName,toUpperCase,toFixed44,toFixed66}



// WEBPACK FOOTER //
// ./src/utils/filters.js